import AiGuideSearchPage from './AiGuideSearchPage'

export default AiGuideSearchPage
// eslint-disable-next-line import/export
export * from './AiGuideSearchPage'
